.all-day-day-column {
  position: relative;
  min-height: 0;
}

.all-day-multi-day-event {
  position: absolute;
  right: 0;
  left: 0;
  height: var(--rc-calendar-minimum-event-height);
  margin-bottom: 1px;
}
